import { getInstance as getConfigServiceInstance } from 'Lib/ConfigService';
import type { ExtractLeverValueType, LeverKey } from 'Lib/ConfigService/types';

export const getLeverValue = <TLeverKey extends LeverKey>(
  leverName: TLeverKey
): ExtractLeverValueType<TLeverKey> => {
  if (!__TEST__) {
    const configService = getConfigServiceInstance();
    return configService.readLever(leverName);
  }
  // @ts-expect-error
  return null;
};
